import { CreditGroupType, PaymentPlan } from "@/data/models/CreditGroups";

export const formatDate = (
  iso?: Date | string | null,
  timeZone?: string | null,
): string | null => {
  if (!iso) return null;
  try {
    const options: Intl.DateTimeFormatOptions = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    };
    if (timeZone) options.timeZone = timeZone;
    return new Date(iso).toLocaleDateString("en-US", options);
  } catch {
    return null;
  }
};

export const creditExpirationText = (
  credits: number,
  nextExpirationIso: string | null,
  type: string,
) => {
  let creditText;
  if (type == CreditGroupType.PACK) {
    creditText = credits == 1 ? "session" : "sessions";
  } else {
    creditText = credits == 1 ? "credit" : "credits";
  }
  const expireText = credits == 1 ? "expires" : "expire";
  return `${credits} ${creditText} ${expireText} ${formatDate(nextExpirationIso)}`;
};

export const calculatePaymentsRemaining = (paymentPlan: PaymentPlan | null) => {
  if (!paymentPlan) return 0;
  if (
    !paymentPlan.payment_plan_billing_cycles_required ||
    !paymentPlan.payment_plan_billing_cycles_required_total
  )
    return 0;

  const remaining =
    paymentPlan.payment_plan_billing_cycles_required -
    paymentPlan.payment_plan_billing_cycles_required_total;

  return remaining > 0 ? remaining : 0;
};
